import styled, { keyframes } from 'styled-components';
import { prop } from 'styled-tools';
import { blue } from 'Styles/colors';

/**
 * Each icon rotates for a total of 924ms, with some sort of animation happening at 0%, 25%, 75%, and 100% of 924ms
 *
 * The total duration is 2100ms to allow all 3 icons enough time to cycle through their rotations (with delay)
 *
 * 924ms * 0.25 / 2100ms = 11%
 */
const rotate = keyframes`
  0% {
    opacity: 0;
    transform: rotate(-45deg);
    display: block;
  }

  11% {
    /* easeInQuint */
    animation-timing-function: cubic-bezier(0.64, 0, 0.78, 0);
    opacity: 1;
    transform: rotate(0deg);
  }

  33% {
    /* easeOutQuint */
    animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
  }

  44% {
    opacity: 0;
    transform: rotate(45deg);
    display: none;
  }
`;

export const Glyph = styled.div`
  animation: ${rotate} 2100ms infinite;
  ${({ delay = 0 }) => `animation-delay: ${delay}ms;`}
  color: ${prop('fill', blue)};
  position: absolute;
  top: calc(50% - 56px / 2);
  left: calc(50% - 56px / 2);
  transform-origin: center center;
  height: 56px;
  width: 56px;
  opacity: 0;
`;

export const Loader = styled.div`
  background: rgba(245, 248, 248, 0.75);
  width: 100%;
  height: 100%;
`;

export const LoadingView = styled.div`
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 1301;
`;

export default Glyph;
